import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up",
  "use": "icon-arrow-up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-up\"><path d=\"M0 128v192h192V256h640v64h192V128h-192v64H192V128H0z m128 128H64V192h64v64z m768-64h64v64h-64V192zM0 896h1024V512H0v384z m64-320h896v256h-64v-192h-64v192h-64v-128h-64v128h-64v-192H576v192H512v-128H448v128H384v-192H320v192H256v-128H192v128H64V576z\" p-id=\"27644\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol